<template>
<div>
    <!-- <nav-bar-home></nav-bar-home> -->
    <main class="main">
        <section>
            <!-- <div class="ef-image">

            </div> -->

        </section>
        <section id="aboutus" class="pr-main" style="padding-top: 0 !important;">
            <div class="container" style="width:100%;padding:0px;margin:0px;">
				
				<div class="ef-header" :style="{ backgroundImage: 'url(' + $store.state.URL + '/uploads/banner/' + $store.state.aboutusPageData.data.banner[0].image + ')', backgroundSize: 'cover', backgroundPosition: 'center' }">
					
					<!-- <h2 class="text-center ab-heading">{{ $store.state.aboutusPageData.data.banner[0].title }}</h2> -->
					<!-- <pre>{{ $store.state.aboutusPageData.data.banner[0] }}</pre>  -->
					<div class="text-center ab-desc" v-html="$store.state.aboutusPageData.data.banner[0].title"></div>
					<div class="text-center ab-desc" v-html="$store.state.aboutusPageData.data.banner[0].text"></div>
				</div>
				
                <div class="col-md-12 col-sm-12 col-xs-12" style="background:white;">
                    <h1 v-html="$store.state.aboutUs.intro[0].introTitle" class=" my-4 acc-title csc lg " :style="{ background: $store.state.aboutUs.intro[0].headingBackColor }">
                        
                    </h1>
                    <p class="tx-intro" v-html="$store.state.aboutUs.intro[0].introContent"></p>
                </div>

                <!-- comment this for future purpose  -->
                <!-- <div class="col-md-12 col-sm-12 col-xs-12" style="background:white;">
					
                    <h1 style="border: none;" class="acc-title csc lg text-center">MEET THE TEAM</h1>
					  <h1 
					v-html="$store.state.aboutusPageData.data.teamHeading" 
					class=" my-4 acc-title csc lg " 
					:style="{ background: $store.state.aboutUs.intro[0].headingBackColor }">
					</h1>
                    <div class="col-md-4 col-sm-4 col-xs-12" v-for="member in $store.state.aboutUs.team" :key="member.id">
                        <div>
                            <img :src="$store.state.URL + '/uploads/team/'+ member.image" height="300" width="300">
                            <h3>{{ member.name }}</h3>
                            <h4>{{ member.role }}</h4>
                            <p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. <span>Lorem ipsum dolor</span> sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. </p>
                        </div>
                    </div>

                </div> -->
                <div class="col-md-12 col-sm-12 col-xs-12" style="background:white;">
					<!-- <pre>{{$store.state.aboutusPageData.data.clientHeading}}</pre> -->
                    <!-- <h1 style="border: none;" class="acc-title csc lg text-center">SOME OF OUR CLIENTS</h1> -->
					<h1 
					v-html="$store.state.aboutusPageData.data.clientHeading" 
					class=" my-4 acc-title csc lg " 
					:style="{ background: $store.state.aboutUs.intro[0].headingBackColor }">
					</h1>
                    <div class="col-xs-12 client-logo-section">
                        <carousel :autoplay="true" :loop="true" :perPageCustom="[[480, 2], [768, 4]]" :autoplayTimeout="6000">
                            <slide v-for="member in $store.state.aboutUs.clients" :key="member.id">
                                <div class="client-logo-item">
                                    <img :src="$store.state.URL+'/uploads/clients/'+member.image" :alt="member.title">
                                </div>
                            </slide>
                        </carousel>
                    </div>
                </div>
                <div class="col-md-12 col-sm-12 col-xs-12" style="background:white;">
					<h1 v-html="$store.state.aboutusPageData.data.testimonialHeading" class=" my-4 acc-title csc lg " :style="{ background: $store.state.aboutUs.intro[0].headingBackColor }"></h1>
                    <div class="col-xs-12 testimonial-section">
                        <carousel :autoplay="true" :loop="true" :perPageCustom="[[480, 1], [768, 1]]" :autoplayTimeout="6000">
                            <slide v-for="member in $store.state.aboutUs.tests" :key="member.id">
                                <div class="testimonial-card">
                                    <blockquote class="testimonial-text" v-html="member.text"></blockquote>
                                    <div class="testimonial-author">
                                        <div class="author-image-wrapper">
                                            <img :src="$store.state.URL+'/uploads/tests/'+member.image" alt="Author image" class="author-image">
                                        </div>
                                        <div class="author-details">
                                            <p class="author-name" v-html="member.title"></p>
                                            <p class="author-desc" v-html="member.desc"></p>
                                        </div>
                                    </div>
                                </div>
                            </slide>
                        </carousel>
                    </div>
                </div>
            </div>
        </section>

    </main>
    <!--Main index : End-->
    <!-- <div>
        <footer-section></footer-section>
    </div> -->
</div>
</template>

<script>
import NavBarHome from "@/components/NavBarHome.vue"
import FooterSection from "@/components/FooterSection.vue"
export default {
    components: {
        NavBarHome,
        FooterSection
    },
    methods: {
        getImgUrl(pet) {
            var images = require.context('../../public/images/team/', false, /\.png$/)
            return images('./' + pet)
        },
        sanitizeLink(link) {
            // Remove any HTML tags from the link
            return link ? link.replace(/<[^>]*>/g, '') : '';
        }
    },
    mounted() {
        this.$store.dispatch("getaboutusPageData")
        setTimeout(() => {
            window.scrollTo(0, 5);

        }, 500);
    }
}
</script>

<style>
.ef-header {
    /* margin-bottom: 62px; */
    height: 300px;    
    display: flex;
    justify-content: center;
    align-items: center;
}

.ef-image {
    height: 345px;
    top: 170px;
    position: fixed;
    width: 100%;
    background-image: url('../../public/images/Online-Print-Shop-scaled.jpg');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
}

.ab-desc {
    text-align: center;
    color: #FFFEFE !important;
    font-family: "Roboto", Sans-serif !important;
    font-size: 31px !important;
    position: relative !important;
    line-height: 110px !important;
    font-weight: 400 !important;
    text-shadow: 0px 0px 10px rgb(0 0 0 / 30%) !important;
}

.ab-heading {
    margin-top: 55px;
    color: #FCFCFC !important;
    font-family: "Roboto", Sans-serif !important;
    font-size: 58px !important;
    font-weight: 600 !important;
    text-shadow: 0px 0px 10px rgb(0 0 0 / 30%);
    border: none !important;
}

.tx-intro {
    text-align: center;
    font-family: "Poppins", Sans-serif;
    font-weight: 400;
    line-height: 27px !important;
}

.elementor-widget:not(:last-child) {
    margin-bottom: 20px;
}

.elementor:not(.elementor-bc-flex-widget) .elementor-widget-wrap {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}

.elementor-widget-wrap>.elementor-element {
    width: 100%;
}

.elementor-widget-wrap {
    position: relative;
    width: 100%;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -ms-flex-line-pack: start;
    align-content: flex-start;
}

.elementor-section {
    background-image: url('../../public/images/Online-Print-Shop-scaled.jpg');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
}

.csc {
    border: none;
    margin: 20px 0px !important;
    padding: 14px 0px !important;
    color: #FFF !important;
}

#aboutus *{
    line-height: 1.5;
}

.testimonial-section .testimonial-card {
    padding: 2rem 1rem;
    text-align: center;
    max-width: 700px;
    margin: 0 auto;
}

.testimonial-section .testimonial-text {
    font-size: 1.1rem;
    font-style: italic;
    color: #555;
    margin-bottom: 2rem;
    quotes: "“" "”";
    position: relative;
    padding: 0 20px;
}

.testimonial-section .testimonial-text::before {
    content: open-quote;
    font-size: 4rem;
    color: #ddd;
    position: absolute;
    left: -10px;
    top: -20px;
    line-height: 1;
}

.testimonial-section .testimonial-text::after {
    content: close-quote;
    font-size: 4rem;
    color: #ddd;
    position: absolute;
    right: 0px;
    bottom: -30px;
    line-height: 1;
}

.testimonial-section .testimonial-author {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
    margin-top: 1.5rem;
}

.testimonial-section .author-image-wrapper {
    flex-shrink: 0;
}

.testimonial-section .author-image {
    width: 200px;
    height: auto;
    /* border-radius: 50%; */
    object-fit: cover;
    border: 3px solid #eee;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.testimonial-section .author-details {
    text-align: left;
}

.testimonial-section .author-name {
    font-weight: bold;
    margin: 0;
    line-height: 1.2;
}

.testimonial-section .author-desc {
    font-size: 0.9rem;
    color: #777;
    margin: 0;
    line-height: 1.2;
}

/* Responsive styles */
@media (max-width: 576px) {
    .testimonial-section .testimonial-author {
        flex-direction: column;
        text-align: center;
    }
    .testimonial-section .author-details {
        text-align: center;
    }
}

.client-logo-section {
    padding: 2rem 0;
}

.client-logo-item {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem;
    height: 100px; 
}

.client-logo-item img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    filter: grayscale(100%);
    opacity: 0.7;
    transition: all 0.3s ease-in-out;
}

.client-logo-item:hover img {
    filter: grayscale(0%);
    opacity: 1;
    transform: scale(1.1);
}
</style>
